<ng-container [appPreloader]="[endpoints.INCOME_SOURCES_POST,
                               endpoints.INCOME_SOURCES_PUT,
                               endpoints.INCOME_SOURCE_FORECAST_POST,
                               endpoints.INCOME_SOURCE_FORECAST_PUT]"
  [preloaderType]="preloaderTypes.OVERLAY">
  @if (form) {
    <div>
      <div class="title align-v-center m-15">
        <i class="icon icon-wallet mr-15 is-big ic-secondary"></i>
        <div>
          <h5>Create payers and forecasts</h5>
          <div>A payer name could be a Ticker or Investment name, and forecasts can be updated anytime to estimate your tax correctly</div>
        </div>
      </div>
      <div class="tabs">
        @if (!incomeSource.id) {
          <div
            id="onBoardingOtherIncomeAdd"
            class="tab-add"
            (click)="addFormGroup()">
            <i class="fa fa-plus-circle"></i>
            Add Income
          </div>
        }
        @for (group of form.controls; track group; let i = $index) {
          <div class="tab d-flex align-v-center"
            [class.active]="i === displayedFormIndex"
            (click)="selectForm(i)">
            {{group.get('incomeSourceForecasts').controls[0]?.get('incomeSourceType').value?.name || 'Other Income ' + (i + 1)}}
            @if (form.controls.length > 1) {
              <button
                appStopPropagation
                (click)="removeForm(i)"
                class="btn icon-close">
              </button>
            }
          </div>
        }
      </div>
      <form [formGroup]="form" appFormErrorScroll>
        @for (group of form.controls; track group; let i = $index) {
          @if (i === displayedFormIndex) {
            <ng-container [formGroup]="group">
              <div class="row">
                @if (group.get('name').enabled) {
                  <div class="col-12 col-md-6">
                    <mat-form-field>
                      <mat-label>Payer</mat-label>
                      <div id="onBoardingOtherIncomePayerAdd">
                        <input matInput formControlName="name" placeholder="Enter Payer Name">
                      </div>
                      @if (group.get('name').invalid) {
                        <mat-error>
                          <app-validation-error [errors]="group.get('name').errors"></app-validation-error>
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                <ng-container formArrayName="incomeSourceForecasts">
                  @for (otherIncomeControl of group.get('incomeSourceForecasts')['controls']; track otherIncomeControl; let i = $index) {
                    <ng-container [formGroup]="otherIncomeControl">
                      @if (otherIncomeControl.get('incomeSource').enabled) {
                        <div class="col-12 col-md-6">
                          <mat-form-field>
                            <mat-label>Payer</mat-label>
                            <mat-select formControlName="incomeSource"
                              [placeholder]="(salaryIncomeSources$ | async).length ? 'Select Payer' : 'You have no salary incomes. Please add at least one!'"
                              [compareWith]="compareFn">
                              @for (salaryIncomeSource of (salaryIncomeSources$ | async); track salaryIncomeSource) {
                                <mat-option
                                  [value]="salaryIncomeSource">
                                  {{salaryIncomeSource.name}}
                                </mat-option>
                              }
                              @if (!incomeSources) {
                                <div matSuffix>
                                  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                                </div>
                              }
                            </mat-select>
                            @if (otherIncomeControl.get('incomeSource').invalid) {
                              <mat-error>
                                <app-validation-error [errors]="otherIncomeControl.get('incomeSource').errors"></app-validation-error>
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      }
                      <!-- order-first class is used to put "Income type" before "Income name" and not use it outside the formGroup-->
                      <div class="col-12 col-md-6 order-first">
                        <mat-form-field>
                          <mat-label>Income Type</mat-label>
                          <mat-select
                            id="onBoardingOtherIncomeTypeSelect"
                            [compareWith]="compareFn" required
                            formControlName="incomeSourceType"
                            placeholder="Select Type Of Income">
                            @for (type of incomeTypes; track type) {
                              <mat-option [value]="type">
                                {{type.name}}
                              </mat-option>
                            }
                          </mat-select>
                          @if (otherIncomeControl.get('incomeSourceType').invalid) {
                            <mat-error>
                              <app-validation-error [errors]="otherIncomeControl.get('incomeSourceType').errors"></app-validation-error>
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      @if (otherIncomeControl.get('amount').enabled) {
                        <div class="col-6">
                          <app-currency-input min="0"
                            formControlName="amount"
                            label="Annual Income"
                            placeholder="Enter Annual Forecast">
                          </app-currency-input>
                        </div>
                      }
                      @if (otherIncomeControl.get('tax').enabled) {
                        <div class="col-6">
                          <app-currency-input min="0"
                            formControlName="tax"
                            label="Tax Withheld"
                            placeholder="Enter Tax Withheld Amount">
                          </app-currency-input>
                        </div>
                      }
                      @if (otherIncomeControl.get('taxInstalments').enabled) {
                        <div class="col-6">
                          <mat-form-field>
                            <mat-label>Tax Instalments</mat-label>
                            <input matInput type="number" formControlName="taxInstalments"
                              placeholder="Enter Tax Instalments Amount">
                              @if (otherIncomeControl.get('taxInstalments').invalid) {
                                <mat-error>
                                  <app-validation-error [errors]="otherIncomeControl.get('taxInstalments').errors"></app-validation-error>
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        }
                        @if (otherIncomeControl.get('trustType').enabled) {
                          <div class="col-6">
                            <mat-form-field>
                              <mat-label>Trust type</mat-label>
                              <mat-select formControlName="trustType"
                                placeholder="Select type">
                                @for (trustType of trustTypes | ekeyvalue | sortBy:'value' :'desc'; track trustType) {
                                  <mat-option [value]="+trustType.key">
                                    {{ trustType.value | translate }}
                                  </mat-option>
                                }
                              </mat-select>
                              @if (otherIncomeControl.get('trustType').invalid) {
                                <mat-error>
                                  <app-validation-error [errors]="otherIncomeControl.get('trustType').errors"></app-validation-error>
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        }
                        @if (otherIncomeControl.get('frankingCredits').enabled) {
                          <div class="col-6">
                            <mat-form-field>
                              <mat-label>Franking Credits</mat-label>
                              <input matInput type="number" formControlName="frankingCredits"
                                placeholder="Enter Franking Credits Forecast">
                                @if (otherIncomeControl.get('frankingCredits').invalid) {
                                  <mat-error>
                                    <app-validation-error [errors]="otherIncomeControl.get('frankingCredits').errors"></app-validation-error>
                                  </mat-error>
                                }
                              </mat-form-field>
                            </div>
                          }
                        </ng-container>
                      }
                    </ng-container>
                  </div>
                </ng-container>
              }
            }
          </form>
        </div>
      }
    </ng-container>
